import { render, staticRenderFns } from "./BlockHistory.vue?vue&type=template&id=2ec77d52&scoped=true"
import script from "./BlockHistory.vue?vue&type=script&lang=js"
export * from "./BlockHistory.vue?vue&type=script&lang=js"
import style0 from "./BlockHistory.vue?vue&type=style&index=0&id=2ec77d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec77d52",
  null
  
)

export default component.exports